export const loginReset = {
  queryFlag: 'reset',
  queryToken: 'token',
  flagOn: '1',
} as const

export const passwordMatch = {
  matchOk: 'Passwords match',
} as const
